import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-body1 text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-sm" }, " Message Us ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@privatefootprint.com" }, "support@privatefootprint.com")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-sm" }, " Call Us ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Monday to Friday"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("9am to 9pm EST ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-bold" }, " 866-906-6161 ext 2 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-bold text-uppercase" }, "Or", -1)
const _hoisted_8 = { class: "q-mt-md" }
const _hoisted_9 = {
  href: "https://outlook.office.com/book/SupportCall@privatefootprint.com/",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_icon, {
      name: "fa fa-envelope",
      size: "1rem"
    }),
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_q_separator, { class: "q-my-lg" }),
    _createVNode(_component_q_icon, { name: "fa fa-phone" }),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("a", _hoisted_9, [
        _createVNode(_component_q_btn, {
          label: "Book a Support Call",
          color: "black",
          unelevated: "",
          "no-caps": "",
          rounded: ""
        })
      ])
    ])
  ]))
}